
export const groupsCSS = `
  /* Groups component styles */
  @media (max-width: 1024px) {
    .row {
      flex-direction: column; /* Stack vertically on smaller screens */
    }

    .row > div {
      width: 100%; /* Full width for inputs on smaller screens */
    }
  }
  .h4-title-size {
    margin-bottom: 0 !important;
    align-self: center !important;
    font-size: 24px !important;
  }
`;

